import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";
import { useState } from "react";
import { useFindAllRecallsQuery } from "../../../../features/recallsApi";
import { MonthCalendar } from "../../../pages/calendar/calendars/monthCalendar";
import { WeekCalendar } from "../../../pages/calendar/calendars/weekCalendar";
import { EventDTO, EventsFiltersDTO } from "../../../pages/calendar/dto";
import { MonthCalendarFilters } from "../../../pages/calendar/filters/monthFilters";
import { WeekCalendarFilters } from "../../../pages/calendar/filters/weekFilters";
import { useMonthCalendar } from "./monthCalendar";
import { useWeekCalendar } from "./weekCalendar";


export const useCalendar = () => {
    const [period, setPeriod] = useState<'month' | 'week'>('month');

    const [visible, setVisible] = useState(false);
    const [eventsDetails, setEventDetails] = useState<EventDTO[]>([]);
    const [event, setEvent] = useState<EventDTO | null>(null);

    const [weekFilters, setWeekFilters] = useState<EventsFiltersDTO>({
        page: 0,
        pageSize: 0,
        sort: '1',
        sortBy: "start_date",
        fromDateTime: startOfWeek(new Date(), { weekStartsOn: 1 }).toISOString(),
        toDateTime: endOfWeek(new Date(), { weekStartsOn: 1 }).toISOString()
    })

    const [monthFilters, setMonthFilters] = useState<EventsFiltersDTO>({
        page: 0,
        pageSize: 0,
        sort: '1',
        sortBy: "start_date",
        fromDateTime: startOfMonth(new Date()).toISOString(),
        toDateTime: endOfMonth(new Date()).toISOString()
    })

    const monthCalendar = useMonthCalendar(monthFilters, setMonthFilters);
    const weekCalendar = useWeekCalendar(weekFilters, setWeekFilters);

    const changePeriod = (period: 'month' | 'week') => {
        setPeriod(period);
    };

    const filters = period === 'month' ? monthFilters : weekFilters;
    const { data, isLoading } = useFindAllRecallsQuery(filters)


    return {
        visible,
        setVisible,
        eventsDetails,
        setEventDetails,
        events: data,
        status: isLoading,
        event,
        period,
        changePeriod,
        calendar: period === 'week' ? weekCalendar : monthCalendar,
        calendarComponent: period === 'week' ?
            <WeekCalendar setEvent={((event: EventDTO) => setEvent(event))} filters={weekCalendar.filters} events={data?.data ?? []} setModalVisible={(visible) => setVisible(visible)} setEventDetails={(events) => setEventDetails(events)} /> :
            <MonthCalendar setEvent={((event: EventDTO) => setEvent(event))} events={data?.data ?? []} filters={monthCalendar.filters} setModalVisible={(visible) => setVisible(visible)} setEventDetails={(events) => setEventDetails(events)} />,
        filterComponents:
            period === 'week' ?
                <WeekCalendarFilters
                    filters={weekCalendar.filters}
                    selectTargertList={e => setWeekFilters({ ...weekFilters, targetListId: e })}
                    changePeriod={function (period: "month" | "week"): void {
                        changePeriod(period);
                    }}
                    changeInterval={function (action: "next" | "prev" | "today"): void {
                        weekCalendar.changeInterval(action);
                    }}
                />
                :
                <MonthCalendarFilters
                    filters={monthCalendar.filters}
                    selectTargertList={e => setMonthFilters({ ...monthFilters, targetListId: e })}
                    // selectTargertList={function (targetListId?: { label: string, value: string }): void {
                    //     dispatch(setFilters({ period: 'month', filters: { targetListId: targetListId } }))
                    // }}
                    changePeriod={function (period: "month" | "week"): void {
                        changePeriod(period);
                    }}
                    changeInterval={function (action: "next" | "prev" | "today"): void {
                        monthCalendar.changeInterval(action);
                    }}
                />
    };
};
